
import { Component, Vue } from 'vue-property-decorator'

@Component({ name: 'MonitorSettings' })
export default class MonitorSettings extends Vue {}
